/** The Dataobjects page's table: every dataobject, what it holds and what uses it. */

export default {
	dataobjectOverview: {
		create: "Neues Datenobjekt",
		search: "Bezeichnung oder Code-Name suchen…",
		noResults: "Keine Datenobjekte gefunden.",
		filter: {
			view: "Ansicht",
			noView: "In keiner Ansicht",
			usage: "Verwendet in",
			unused: "Nicht verwendet",
			related: "In Beziehung zu",
		},
		attentionCount: "Handlungsbedarf ({n})",
		resizeColumn: "Breite von {column} ändern",
		rows: {
			label: "Zeilen",
			dataobjects: "Datenobjekte",
			attributes: "Attribute",
		},
		searchAttributes: "Attribute und Beziehungen suchen…",
		attributeColumns: {
			attribute: "Attribut",
			type: "Typ",
			required: "Erforderlich",
			axiom: "Axiom",
			target: "Ziel",
		},
		attributeCells: {
			relation: "Beziehung",
			required: "Erforderlich",
			optional: "Optional",
			list: "{type}[]",
			axiomReads: "aus {fields}",
			// A group band's count, attributes and relations apart; "… of…" while the search or
			// "Needs attention" narrows the rows. Plural by the total.
			count: {
				attributes: "{n} Attribut | {n} Attribute",
				attributesNarrowed: "{n} von {total} Attribut | {n} von {total} Attributen",
				relations: "{n} Beziehung | {n} Beziehungen",
				relationsNarrowed: "{n} von {total} Beziehung | {n} von {total} Beziehungen",
			},
		},
		columns: {
			dataobject: "Datenobjekt",
			attributes: "Attribute",
			relations: "Bezieht sich auf",
			views: "In Ansichten",
			usedIn: "Verwendet in",
			terminology: "Terminologie",
		},
		cells: {
			axioms: "{n} Axiom | {n} Axiome",
			noRelations: "Keine",
			relatedFrom: "← von",
			relatesToHeading: "{name} bezieht sich auf",
			allRelatesTo: "Alle {n} Datenobjekte, auf die sich {name} bezieht",
			relatedFromHeading: "Beziehen sich auf {name}",
			allRelatedFrom: "Alle {n} Datenobjekte, die sich auf {name} beziehen",
			noView: "In keiner Ansicht",
			notUsed: "Noch nicht verwendet",
			manualName: "Code-Name von Hand festgelegt",
			predefined: "Notitia",
			fromAlias: "Aus {alias}",
			unverified: "{n} ungeprüft",
			coverage: "{filled} / {total}",
			missingNamed: "Fehlt: {langs}",
			missingCount: "{n} fehlen",
			allProcesses: "Alle {n} Prozesse, die {name} verwenden",
			viewsShowing: "Ansichten mit {name}",
			allViews: "Alle {n} Ansichten mit {name}",
			processesUsing: "Prozesse, die {name} verwenden",
			activitiesOf: "Aktivitäten von {name}",
			allActivities: "Alle {n} Aktivitäten von {name}",
		},
		menu: {
			more: "Weitere Aktionen für {name}",
			openInView: "In Ansicht öffnen",
			addToView: "Zu Ansicht hinzufügen",
		},
		places: {
			createAndOpen: "Erstellen und öffnen",
			newView: "Neue Ansicht…",
		},
		usage: {
			tab: "Verwendet in",
			terminology: "Terminologie",
			noLabel: "Keine Bezeichnung",
			unverified: "Ungeprüft",
			views: "Ansichten",
			processes: "Prozesse",
			activities: "Aktivitäten",
			none: "Keine",
			addToView: "Zu Ansicht hinzufügen",
			newActivity: "Neue Aktivität",
		},
		createDialog: {
			label: "Bezeichnung",
			codeName: "Code-Name {name}",
			color: "Farbe",
			view: "Zu einer Ansicht hinzufügen",
			optional: "Optional",
			noView: "Keine Ansicht — es bleibt in dieser Tabelle",
		},
		deleteDialog: {
			title: "{name} löschen?",
			intro: "Wenn Sie {name} löschen, wird alles unten Aufgeführte mit entfernt. Das lässt sich nicht rückgängig machen.",
			introAlone:
				"Nichts anderes verweist auf {name}. Das lässt sich nicht rückgängig machen.",
			relations: "Beziehungen, die darauf zeigen — werden entfernt",
			activities: "Seine Aktivitäten — werden mit gelöscht",
			views: "Ansichten — es wird daraus entfernt",
			leftBehind: "Sein Terminologieeintrag bleibt",
			leftBehindNote:
				"Die Bezeichnung und ihre Übersetzungen werden nicht gelöscht. Sie bleiben in der Terminologieliste, ohne Bezug.",
			confirm: "{name} löschen",
			blockedTitle: "{name} kann nicht gelöscht werden",
			blockedIntro:
				"Andere Teile des Modells bauen auf {name} auf. Ändern Sie diese zuerst, und löschen Sie es dann.",
			processes: "Prozesse, die es verwenden",
			embeds: "Attribute vom Typ {name}",
			axioms: "Axiome, die es lesen",
			actions: "Aktionen, die es verwenden",
			actionMakes: "erzeugt es",
			actionActsOn: "wirkt darauf ein",
			actionRelation: "verwendet {relation}",
		},
	},
};
